module.exports = __webpack_public_path__ + "img/door-closed.52a08f14.svg";